import {
  CreateSkillRequest,
  LocalizedProperty,
  SkillDto,
  State,
  UpdateSkillRequest,
} from "../../interfaces";
import { Paginated } from "../../models";
import { TOGGLE_ADD_EDIT_QUESTION_MODAL } from "../question/actionTypes";
import {
  ADD_SKILL,
  ADD_SKILL_ERROR,
  ADD_SKILL_SUCCESS,
  ActionTypes,
  COPY_SKILLS,
  COPY_SKILLS_ERROR,
  COPY_SKILLS_SUCCESS,
  DELETE_SKILL,
  DELETE_SKILL_CONSENT,
  DELETE_SKILL_ERROR,
  DELETE_SKILL_SUCCESS,
  GET_SKILL,
  GET_SKILLS,
  GET_SKILLS_BY_LESSON,
  GET_SKILLS_BY_LESSON_ERROR,
  GET_SKILLS_BY_LESSON_SUCCESS,
  GET_SKILLS_BY_SUBJECT,
  GET_SKILLS_BY_SUBJECT_ERROR,
  GET_SKILLS_BY_SUBJECT_SUCCESS,
  GET_SKILLS_ERROR,
  GET_SKILLS_SUCCESS,
  GET_SKILLS_SUGGESTION,
  GET_SKILLS_SUGGESTION_ERROR,
  GET_SKILLS_SUGGESTION_SUCCESS,
  GET_SKILL_ERROR,
  GET_SKILL_SUCCESS,
  RESET_COPY_CUT_SKILLS,
  TOGGLE_ADD_EDIT_SKILL_MODAL,
  TOGGLE_SKILL_STATE,
  TOGGLE_SKILL_STATE_ERROR,
  TOGGLE_SKILL_STATE_SUCCESS,
  UPDATE_SKILL,
  UPDATE_SKILL_ERROR,
  UPDATE_SKILL_SUCCESS,
  UPLOAD_SKILL_VIDEO,
  UPLOAD_SKILL_VIDEO_ERROR,
  UPLOAD_SKILL_VIDEO_PROGRESS,
  UPLOAD_SKILL_VIDEO_SUCCESS,
} from "./actionTypes";

export class SkillState {
  skills!: State<Paginated<SkillDto[]>>;
  skillsByLesson!: State<SkillDto[]>;
  skillsBySubject!: State<SkillDto[]>;
  skill!: State<SkillDto>;
  addSkill!: State<CreateSkillRequest>;
  updateSkill!: State<UpdateSkillRequest>;
  deleteSkill!: State<any>;
  uploadSkillVideo: State<File>;
  skillsSuggestion: State<SkillDto[]>;
  uploadSkillVideoProgress: number;
  toggleSkillState: any;
  copySkills: any;
  constructor() {
    this.skills = {
      loading: false,
      error: null,
      success: false,
    };
    this.skillsByLesson = {
      loading: false,
      error: null,
      success: false,
    };
    this.skillsBySubject = {
      loading: false,
      error: null,
      success: false,
    };
    this.skill = {
      loading: false,
      error: null,
      success: false,
    };
    this.addSkill = {
      loading: false,
      error: null,
      success: false,
    };
    this.updateSkill = {
      loading: false,
      error: null,
      success: false,
    };
    this.deleteSkill = {
      loading: false,
      error: null,
      success: false,
    };
    this.uploadSkillVideo = {
      loading: false,
      error: null,
      success: false,
    };
    this.skillsSuggestion = {
      loading: false,
      error: null,
      success: false,
    };
    this.toggleSkillState = {
      loading: false,
      error: null,
      success: false,
    };
    this.copySkills = {
      loading: false,
      error: null,
      success: false,
    };
    this.uploadSkillVideoProgress = 0;
  }
}

const initialState: SkillState = new SkillState();

export const skill = (
  state: SkillState = initialState,
  action: ActionTypes
) => {
  switch (action.type) {
    case GET_SKILLS:
      state = {
        ...state,
        skills: {
          ...state.skills,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case GET_SKILLS_SUCCESS:
      state = {
        ...state,
        skills: {
          ...state.skills,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_SKILLS_ERROR:
      state = {
        ...state,
        skills: {
          ...state.skills,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case GET_SKILLS_BY_LESSON:
      state = {
        ...state,
        skillsByLesson: {
          ...state.skillsByLesson,
          loading: true,
          success: false,
          error: null,
        },
        skill: {
          ...state.skill,
          response: undefined,
        },
      };
      break;
    case GET_SKILLS_BY_LESSON_SUCCESS:
      state = {
        ...state,
        skillsByLesson: {
          ...state.skillsByLesson,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_SKILLS_BY_LESSON_ERROR:
      state = {
        ...state,
        skillsByLesson: {
          ...state.skillsByLesson,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case GET_SKILLS_BY_SUBJECT:
      state = {
        ...state,
        skillsBySubject: {
          ...state.skillsBySubject,
          loading: true,
          success: false,
          error: null,
        },
        skill: {
          ...state.skill,
          response: undefined,
        },
      };
      break;
    case GET_SKILLS_BY_SUBJECT_SUCCESS:
      state = {
        ...state,
        skillsBySubject: {
          ...state.skillsBySubject,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_SKILLS_BY_SUBJECT_ERROR:
      state = {
        ...state,
        skillsBySubject: {
          ...state.skillsBySubject,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case GET_SKILL:
      state = {
        ...state,
        skill: {
          ...state.skill,
          loading: true,
          success: false,
          error: null,
        },
        addSkill: {
          ...state.addSkill,
          loading: false,
          success: false,
          error: null,
        },
        updateSkill: {
          ...state.updateSkill,
          loading: false,
          success: false,
          error: null,
        },
      };
      break;
    case GET_SKILL_SUCCESS:
      state = {
        ...state,
        skill: {
          ...state.skill,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_SKILL_ERROR:
      state = {
        ...state,
        skill: {
          ...state.skill,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case ADD_SKILL:
      state = {
        ...state,
        addSkill: {
          ...state.addSkill,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case ADD_SKILL_SUCCESS:
      state = {
        ...state,
        addSkill: {
          ...state.addSkill,
          loading: false,
          error: null,
          success: true,
        },
        skillsByLesson: {
          ...state.skillsByLesson,
          response: [
            action.payload,
            ...(state.skillsByLesson.response as SkillDto[]),
          ],
        },
      };
      break;
    case ADD_SKILL_ERROR:
      state = {
        ...state,
        addSkill: {
          ...state.addSkill,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;

    case UPDATE_SKILL:
      state = {
        ...state,
        updateSkill: {
          ...state.updateSkill,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case UPDATE_SKILL_SUCCESS: {
      const updatedItem = action.payload;
      const indexToUpdate: number | undefined =
        state.skillsByLesson.response?.findIndex(
          (item) => item.id == updatedItem.id
        );
      const updatedItems = [...(state.skillsByLesson.response as SkillDto[])];
      if (indexToUpdate !== undefined && Number(indexToUpdate) >= 0) {
        updatedItems[indexToUpdate] = updatedItem;
      }
      state = {
        ...state,
        updateSkill: {
          ...state.updateSkill,
          loading: false,
          error: null,
          success: true,
        },
        skillsByLesson: {
          ...state.skillsByLesson,
          response: [...updatedItems],
        },
      };
      break;
    }
    case UPDATE_SKILL_ERROR:
      state = {
        ...state,
        updateSkill: {
          ...state.updateSkill,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case DELETE_SKILL_CONSENT:
      state = {
        ...state,
        deleteSkill: {
          ...state.deleteSkill,
          loading: false,
          success: false,
          error: null,
        },
      };
      break;
    case DELETE_SKILL:
      state = {
        ...state,
        deleteSkill: {
          ...state.deleteSkill,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case DELETE_SKILL_SUCCESS:
      state = {
        ...state,
        deleteSkill: {
          ...state.deleteSkill,
          loading: false,
          error: null,
          success: true,
        },
        skillsByLesson: {
          ...state.skillsByLesson,
          loading: false,
          error: null,
          success: false,
          response: state.skillsByLesson.response?.filter(
            (item) => item.id !== action.payload
          ),
        },
      };
      break;
    case DELETE_SKILL_ERROR:
      state = {
        ...state,
        deleteSkill: {
          ...state.deleteSkill,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case UPLOAD_SKILL_VIDEO:
      state = {
        ...state,
        uploadSkillVideo: {
          ...state.uploadSkillVideo,
          loading: true,
          success: false,
          error: null,
        },
        uploadSkillVideoProgress: 0,
      };
      break;
    case UPLOAD_SKILL_VIDEO_SUCCESS:
      state = {
        ...state,
        uploadSkillVideo: {
          ...state.uploadSkillVideo,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
        skill: {
          ...state.skill,
          response: {
            name: state.skill.response?.name as LocalizedProperty,
            video: action.payload,
            content: state.skill.response?.content as LocalizedProperty,
            createdAt: state.skill.response?.createdAt as Date,
            createdBy: state.skill.response?.createdBy as string,
            deletedAt: state.skill.response?.deletedAt as Date,
            deletedBy: state.skill.response?.deletedBy as string,
            id: state.skill.response?.id as string,
            isActive: state.skill.response?.isActive as boolean,
            modifiedAt: state.skill.response?.modifiedAt as Date,
            modifiedBy: state.skill.response?.modifiedBy as string,
          },
        },
        uploadSkillVideoProgress: 0,
      };
      break;
    case UPLOAD_SKILL_VIDEO_ERROR:
      state = {
        ...state,
        uploadSkillVideo: {
          ...state.uploadSkillVideo,
          loading: false,
          success: false,
          error: action.payload,
        },
        uploadSkillVideoProgress: 0,
      };
      break;
    case UPLOAD_SKILL_VIDEO_PROGRESS:
      state = {
        ...state,
        uploadSkillVideoProgress: action.payload,
      };
      break;
    case TOGGLE_ADD_EDIT_SKILL_MODAL:
      state = {
        ...state,
        skill: {
          ...state.skill,
          loading: false,
          success: false,
          error: null,
          response: undefined,
        },
      };
      break;
    case GET_SKILLS_SUGGESTION:
      state = {
        ...state,
        skillsSuggestion: {
          ...state.skillsSuggestion,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case GET_SKILLS_SUGGESTION_SUCCESS:
      state = {
        ...state,
        skillsSuggestion: {
          ...state.skillsSuggestion,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_SKILLS_SUGGESTION_ERROR:
      state = {
        ...state,
        skillsSuggestion: {
          ...state.skillsSuggestion,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case TOGGLE_ADD_EDIT_QUESTION_MODAL:
      state = {
        ...state,
        skillsSuggestion: {
          ...state.skillsSuggestion,
          loading: false,
          success: false,
          error: null,
          response: undefined,
        },
      };
      break;
    case TOGGLE_SKILL_STATE:
      state = {
        ...state,
        toggleSkillState: {
          ...state.toggleSkillState,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case TOGGLE_SKILL_STATE_SUCCESS:
      state = {
        ...state,
        toggleSkillState: {
          ...state.toggleSkillState,
          loading: false,
          error: null,
          success: true,
        },
        skillsByLesson: {
          ...state.skillsByLesson,
          response: state.skillsByLesson?.response?.map((skill: SkillDto) => {
            if (skill.id === action.payload.id)
              return { ...skill, isActive: !skill.isActive };
            return skill;
          }),
        },
      };
      break;
    case TOGGLE_SKILL_STATE_ERROR:
      state = {
        ...state,
        toggleSkillState: {
          ...state.toggleSkillState,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case COPY_SKILLS:
      state = {
        ...state,
        copySkills: {
          ...state.copySkills,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case COPY_SKILLS_SUCCESS:
      state = {
        ...state,
        copySkills: {
          ...state.copySkills,
          loading: false,
          error: null,
          success: true,
        },
      };
      break;
    case COPY_SKILLS_ERROR:
      state = {
        ...state,
        copySkills: {
          ...state.copySkills,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case RESET_COPY_CUT_SKILLS:
      state = {
        ...state,
        copySkills: {
          ...state.copySkills,
          loading: false,
          success: false,
          error: null,
          response: undefined,
        },
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};
